import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import styled from 'styled-components'

export const Footer = styled.footer`
  padding: 96px 0;
  margin: 0 auto;
  background-color: ${COLORS.nature[95]};
  color: ${COLORS.secondary};
  position: relative;
  z-index: 99;

  @media ${DEVICES.tablet} {
    padding: 80px 0 60px;
    z-index: 11;
  }

  @media ${DEVICES.mobile} {
    padding: 60px 0;
  }
`

export const FooterInner = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 42px;

  @media ${DEVICES.mobile} {
    padding: 0 16px;
  }
`

export const FooterBottom = styled.div`
  font-size: 12px;
  line-height: 18px;
`

export const FooterBottomGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  flex-wrap: wrap;

  > a {
    font-size: 0;
    line-height: 0;
  }

  &:first-child {
    border-bottom: 1px solid rgba(0, 31, 185, 0.4);
    padding-bottom: 20px;
    margin-bottom: 24px;
  }

  @media ${DEVICES.tablet} {
    &:last-child {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }
  }

  @media ${DEVICES.mobile} {
    &:first-child {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }
`

export const FooterLogo = styled.img`
  @media ${DEVICES.mobile} {
    margin-bottom: 24px;
  }
`

export const Copyright = styled.p`
  flex: 1;
  white-space: nowrap;
  color: ${COLORS.navi};

  span {
    display: block;
  }

  @media ${DEVICES.tablet} {
    margin-bottom: 64px;
  }
`

export const FooterBottomLinks = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  justify-content: flex-end;
  flex-wrap: wrap;

  a {
    color: ${COLORS.secondary};

    &:hover {
      text-decoration: none;
      color: ${COLORS.primary};
      opacity: 1;
    }
  }

  @media ${DEVICES.tablet} {
    justify-content: flex-start;
    margin-left: 0;
    width: 100%;
  }
`

export const FooterBottomLink = styled.div`
  margin-left: 35px;
  display: inline-block;
  color: ${COLORS.secondary};

  @media ${DEVICES.tablet} {
    margin: 0;
    width: 50%;
    flex: 0 0 50%;
    margin-bottom: 8px;
  }
`
